module.exports = ".top {\n    top: 0;\n}\n\n.bottom {\n    position: fixed;\n    bottom: 0;\n}\n\n.panel {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n/deep/ body{\n    overflow: hidden;\n}\n\n/deep/ .bottom.panel{\n    opacity: 1;\n    z-index: 999999;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.css
// module id = ./src/app/components/app/app.component.css
// module chunks = main